import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getUtility } from '@livable/saas-react-components';
import { Typography, ToggleButtonGroup, ToggleButton } from '@mui/material';
import React, { useState } from 'react';
import useStyles from './styles';
import FinancialTextInput from 'src/components/shared/FinancialTextInput';
import { useTranslation } from 'react-i18next';
export default function Utility(_ref) {
  let utility = _ref.utility,
    type = _ref.type,
    providerName = _ref.providerName,
    utilityId = _ref.utilityId,
    handleChange = _ref.handleChange,
    utilityCapExternal = _ref.utilityCapExternal,
    handleCapChange = _ref.handleCapChange;
  const classes = useStyles();
  const utilityData = getUtility(utility);
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(type === 0 ? 'RatioBilling' : 'Optout'),
    _useState2 = _slicedToArray(_useState, 2),
    billing = _useState2[0],
    setBilling = _useState2[1];
  const handleBillingChange = (e, value) => {
    if (value) {
      setBilling(value);
      handleChange(utilityId, value);
    }
  };
  const capitalizeFirstLetter = string => {
    var _string$charAt;
    return ((_string$charAt = string.charAt(0)) === null || _string$charAt === void 0 ? void 0 : _string$charAt.toUpperCase()) + string.slice(1);
  };
  const isUtilityCombinedName = string => {
    return string.indexOf('/') !== -1;
  };
  const splitCombinedUtilityName = (string, splitVal) => {
    return string.split(splitVal);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.utilityWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.utilityIconWrapper
  }, utilityData.icon()), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, isUtilityCombinedName(utilityData.title) ? splitCombinedUtilityName(utilityData.title, '/').map(i => capitalizeFirstLetter(i)).join('/') : capitalizeFirstLetter(utilityData.title), providerName ? " (".concat(providerName, ")") : '')), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtons
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: billing,
    onChange: handleBillingChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "RatioBilling"
  }, "Ratio Billing"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "Optout"
  }, "Opt-out")), billing === 'RatioBilling' && /*#__PURE__*/React.createElement("div", {
    className: classes.smField
  }, /*#__PURE__*/React.createElement(FinancialTextInput, {
    inputLabel: 'Utility cap',
    withAdorment: true,
    valueExt: utilityCapExternal,
    handleInputChange: value => handleCapChange(utilityId, value),
    infoMark: t('enrollment_modal.utility_cap_help_info'),
    infoMarkNullPaddingMargin: false
  }))));
}